import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { FAZILService, User, UserService } from 'src/app/core';
import { environment } from 'src/environments/environment';
import { ConfirmationService, Message, MessageService } from 'primeng/api';
import { UIService } from '../core/services/ui.service';
import { DataService } from '../services/data.service';

@Component({
    templateUrl: './inicio.component.html',
    styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    currentUser: User;
    isAuthenticated: boolean;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private fazilService: FAZILService,
        private uiService: UIService,
        private dataService: DataService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
    ) {
    }

    ngOnInit() {
        this.userService.isAuthenticated.subscribe(
            (authenticated) => {
                this.isAuthenticated = authenticated;
                if (!this.isAuthenticated) {
                    this.router.navigateByUrl('login');
                    return;
                } else {
                    this.userService.currentUser.subscribe(userData => {
                        this.currentUser = userData;
                        if (this.currentUser && this.currentUser.uuid) {
                            this.irAInicio(null); //Mostrar el asistente
                        } else if (!this.currentUser.puedeFacturarPorPlan) {
                            this.fazilService.irALanding();
                        }
                    });
                }
            }
        );
    }

    irAInicio(event) {
        this.fazilService.irAInicio();
    }

}

